import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export const STORAGE_KEY = 'verse_cookie_consent'
const DEFAULT = { necessary: true, decided: false }

function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT }
    return { ...DEFAULT, ...JSON.parse(raw) }
  } catch (err) {
    console.error('[CookieBanner] Failed to read cookie consent from localStorage:', err)
    return { ...DEFAULT }
  }
}

export function useCookieConsent() {
  const [consent, setConsent] = useState(readConsent)

  useEffect(() => {
    function onStorage(e) {
      if (e.key === STORAGE_KEY) setConsent(readConsent())
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  return consent
}

export default function CookieBanner() {
  const [consent] = useState(readConsent)
  const [visible, setVisible] = useState(false)
  const [slideOut, setSlideOut] = useState(false)

  useEffect(() => {
    if (!consent.decided) {
      const t = setTimeout(() => setVisible(true), 400)
      return () => clearTimeout(t)
    }
  }, [])

  if (!visible) return null

  function accept() {
    const next = { necessary: true, decided: true }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    setSlideOut(true)
    setTimeout(() => setVisible(false), 350)
  }

  return (
    <div className={`cookie-banner${slideOut ? ' cookie-banner--out' : ''}`} role="dialog" aria-label="Cookie consent" onKeyDown={(e) => { if (e.key === 'Escape') accept() }}>
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__title">We use cookies 🍪</p>
          <p className="cookie-banner__desc">
            We use essential cookies to keep you logged in. No tracking, no ads, no third-party cookies.
            {' '}<Link to="/cookie-policy" className="cookie-banner__link">Learn more</Link>
          </p>
        </div>

        <div className="cookie-banner__actions">
          <button className="btn btn-primary cookie-banner__btn" onClick={accept}>
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}
